/**
 * Meta Pixel (Facebook) Wrapper
 * Abstração segura sobre window.fbq.
 */

import { config } from '../../config';
import { debug } from '../debug';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Dispara um evento Meta Pixel se disponível.
 */
export function fbqEvent(
  eventName: string,
  params?: Record<string, unknown>
): void {
  if (typeof window === 'undefined') return;
  if (!window.fbq) {
    debug.warn('fbq not loaded, event dropped:', eventName);
    return;
  }
  if (!config.metaPixelId) {
    debug.warn('Meta Pixel ID not configured');
    return;
  }

  window.fbq('track', eventName, params);
  debug.event(`fbq:${eventName}`, params ?? {});
}

/**
 * Inicializa o Meta Pixel base.
 */
export function initFbq(): void {
  if (typeof window === 'undefined') return;
  if (!config.metaPixelId) return;

  // fbq stub
  window.fbq = window.fbq || function (...args: unknown[]) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window.fbq as any).callMethod
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ? (window.fbq as any).callMethod.apply(window.fbq, args)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      : (window.fbq as any).queue.push(args);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (!(window.fbq as any).loaded) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window.fbq as any).loaded = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window.fbq as any).version = '2.0';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window.fbq as any).queue = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window.fbq as any).callMethod = undefined;
  }
}
